export const SOFTWARE_PROJECT_ID = 294;
export const SOFTWARE_PROJECT_NAME = "站房维管信息系统";